<template>
  <InputWrapper
    v-slot="{ inputId }"
    :input-id="id"
    :label="t('lineItems.productNumber')"
    class="order-product-number-filter w-2"
    optional
  >
    <InputText
      :id="inputId"
      v-model="internalValue.productNumber"
      :placeholder="t('lineItems.productNumber')"
    />
  </InputWrapper>
</template>

<script lang="ts" setup>
import { toRefs } from 'vue';
import { useI18n } from 'vue-i18n';

import { OrderSearchCriteria } from '@/model';

import InputWrapper from '@rygen/rygen-ui/components/form/InputWrapper.vue';
import InputText from 'primevue/inputtext';

const internalValue = defineModel<OrderSearchCriteria>('modelValue', {
  type: OrderSearchCriteria,
  default: () => new OrderSearchCriteria(),
});

const props = defineProps({
  id: {
    type: String,
    required: true,
  },
});
const { id } = toRefs(props);
const { t } = useI18n();
</script>
